<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             append-to-body
             :title="title"
             @open="open"
             @closed="closed"
             width="800px">
    <div v-loading="loading">
      <team-select v-model="curTeamIndex" :team-list="teamList" :select-all="!dispatch2Team"></team-select>
      <div class="border" style="height: 300px; margin-top: 10px; overflow-y: auto;">
        <div v-for="(technician, index) of technicians" :key="technician.id" class="card list-complete-item">
          <div style="text-align: center">
            <label v-if="dispatch2Team">{{technician.name}}</label>
            <el-radio v-else v-model="selectedTechnicianIndex" :label="index">{{technician.name}}</el-radio>
          </div>
          <div style="display: flex; justify-content: center; margin-top: 10px">
            <div>
              <div class="card-item">等待</div>
              <div class="card-item">在修</div>
            </div>
            <div>
              <div class="value card-item">{{technician.waitNum}}</div>
              <div class="value card-item">{{technician.workingNum}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <el-button type="primary" @click="confirm" :disabled="disableConfirm">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import { teamsOfTechniciansByProcedure } from '@/utils/request'
  import TeamSelect from '@/components/selector/TeamSelect'

  export default {
    name: 'SelectTechnicianDialog',
    components: { TeamSelect },
    props: {
      procedure: {
        type: Object,
        required: false
      }
    },
    data () {
      return {
        loading: false,
        teamList: [],
        curTeamIndex: -1,
        selectedTechnicianIndex: null
      }
    },
    methods: {
      open () {
        this.loading = true
        this.curTeamIndex = this.dispatch2Team ? null : -1
        teamsOfTechniciansByProcedure(this.procedure.id).then(response => {
          this.teamList = response.data
        }).finally(() => {
          this.loading = false
        })
      },
      closed () {
        this.curTeamIndex = null
        this.teamList = []
        this.selectedTechnicianIndex = null
      },
      cancel () {
        this.hide()
      },
      confirm () {
        if (this.dispatch2Team) {
          this.$emit('selectTeam', this.teamList[this.curTeamIndex])
        } else {
          this.$emit('selectTechnician', this.technicians[this.selectedTechnicianIndex])
        }
        this.hide()
      },
      hide () {
        this.$emit('update:visible', false)
      }
    },
    computed: {
      dispatch2Team () {
        return this.procedure.dispatch2Team
      },
      title () {
        return (this.dispatch2Team ? '选择工组' : '选择技师') + ' - ' + this.procedure.name
      },
      technicians () {
        if (this.curTeamIndex === null) return []
        if (this.curTeamIndex !== -1) return this.teamList[this.curTeamIndex].technicians
        const allTechnicians = []
        this.teamList.forEach(team => allTechnicians.push(...team.technicians))
        return allTechnicians
      },
      disableConfirm () {
        if (this.loading) return true
        if (this.dispatch2Team) {
          return this.curTeamIndex === null || this.curTeamIndex === -1 || this.teamList[this.curTeamIndex].technicians.length === 0
        } else {
          return this.selectedTechnicianIndex === null
        }
      }
    },
    watch: {
      curTeamIndex () {
        this.selectedTechnicianIndex = null
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card {
    display: inline-block;
    margin: 10px;
    width: 80px;
    border: 1px solid #8cc8ff;
    border-radius: 4px;
    padding: 10px
  }

  .card-item {
    height: 24px;
    line-height: 24px;
  }

  .border {
    border: 2px solid #dfdfe2;
  }
</style>
